import { useContext } from 'preact/hooks';
import { SelectionContext, UpdateSelectionContext } from './SelectionsContext';

export const UseVendorSelections = () => {
  const { vendorSelections } = useContext(SelectionContext);
  const { setVendorSelections, setVendor } = useContext(UpdateSelectionContext);
  
  return { vendorSelections, setVendorSelections, setVendor };
};
